export { DynamicPage as default } from '@moonpig/web-explore-find'
